import { render, staticRenderFns } from "./paginated-list-controls.vue?vue&type=template&id=54856efb"
import script from "./paginated-list-controls.vue?vue&type=script&lang=js"
export * from "./paginated-list-controls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports